module.exports = __webpack_public_path__ + "static/media/help.2e5ef37d.svg";